/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_DefaultInputs */



/**
* | output |
* | --- |
* | "caption" |
*
* @param {Ateliere_Connect_Caption_Name_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_default = /** @type {((inputs?: Ateliere_Connect_Caption_Name_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("подпись")
	if (locale === "es") return /** @type {LocalizedString} */ ("subtítulo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("rubrica")
	return /** @type {LocalizedString} */ ("caption")
});